import { BaseViewStore } from 'core/stores';
import { VoidLabelForm } from 'modules/order/forms';
import { observable, action, makeObservable } from 'mobx';
import FulfillmentOrderStore from './FulfillmentOrderStore';
import { LookupStore } from 'modules/lookup/stores';
import { handleVoidLabelResponseNotification, notificationError } from 'core/utils';
import { shipmentInfoStatusEnum, sourceOfChange } from 'common/constants';
import { ShipmentInfoStore } from 'modules/shipment-info/stores';
import _ from 'lodash';

class VoidLabelViewStore extends BaseViewStore {
	@observable selectedVoidLabelOption = null;
	@observable disableSaveBtn = true;
	@observable voidOnChannel = false;
	@observable voidLabelOptions = [{ value: 0, label: 'Void internally' }, { value: 1, label: 'Void on channel' }];
	selectedItem = null;

	form = new VoidLabelForm({
		onSuccess: async () => {
			await this.voidLabel();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.lookupStore = new LookupStore(rootStore);
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
		this.shipmentInfoStore = new ShipmentInfoStore(rootStore);
		this.initialize(_.get(modalParams, 'data.selectedItemId'));
	}

	@action.bound
	initialize = async selectedItemId => {
		this.suspend();
		await this.getFulfillmentOrder(selectedItemId);
		this.resume();
	};

	@action.bound
	getFulfillmentOrder = async selectedItemId => {
		this.selectedItem = await this.fulfillmentOrderStore.getFulfillmentOrder(selectedItemId, {
			embed: ['shipmentInfos'],
		});
		this.isBuyShipping =
			_.find(this.selectedItem.shipmentInfos, item => {
				return (
					item.isBuyShipping == true && item.status == shipmentInfoStatusEnum.active && item.amazonShipmentId != null
				);
			}) != null;
		if (!this.isBuyShipping) {
			this.voidLabelOptions.splice(1, 1);
		}
	};

	@action.bound
	onCheck = async check => {
		if (check) {
			this.voidOnChannel = !this.voidOnChannel;
		}
	};

	@action.bound async voidLabel() {
		try {
			var voidLabelOptionId = this.voidOnChannel ? 1 : 0;
			const response = await this.shipmentInfoStore.voidLabel(
				{ fulfillmentOrderId: this.selectedItem.id },
				voidLabelOptionId,
				sourceOfChange.voidLabel + ' - Void Label Option: ' + voidLabelOptionId
			);

			handleVoidLabelResponseNotification(
				this.rootStore,
				response,
				this.selectedItem.fulfillmentOrderId,
				this.isBuyShipping ? voidLabelOptionId : true
			);
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	}
}

export default VoidLabelViewStore;
